import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Calculators } from "@/components/site/Calculators";
import { ChecklistSection } from "@/components/site/ChecklistSection";
import { HowItWorks } from "@/components/site/HowItWorks";
import { EnquirySection } from "@/components/site/EnquirySection";
import { Footer } from "@/components/site/Footer";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-night min-h-screen text-foreground">
      <Header />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <Manifesto />
        <Calculators />
        <ChecklistSection />
        <EnquirySection />
      </main>
      <Footer />
      <a
        data-testid="whatsapp-float-button"
        href="https://wa.me/918796512777?text=Hi%20Team%2C%20I%20would%20like%20to%20discuss%20a%20loan%20proposal"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-black/40 hover:scale-105 transition-transform"
      >
        <WhatsAppIcon size={28} />
      </a>
    </div>
  );
}
